"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_select_1 = require("react-select");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Control = function (props) {
    var _a;
    var selectProps = props.selectProps, children = props.children;
    return (react_1.default.createElement(react_select_1.components.Control, __assign({}, props),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            ((_a = selectProps === null || selectProps === void 0 ? void 0 : selectProps.value) === null || _a === void 0 ? void 0 : _a.icon) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.optionIcon },
                react_1.default.createElement(selectProps.value.icon, null))),
            children)));
};
exports.default = Control;
